import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { RecentClubModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class RecentClubStore implements ltFramework.IRecentClubStore {
	public initialize(experienceType: string, profileData: ltFramework.IProfile): Promise<void> {
		const recentClubStoreInitObj: ltFramework.IRecentClubStoreInitObj = {
			experienceType,
			profile: profileData
		};

		return Store.dispatch(
			RecentClubModuleConstant.name + '/' + RecentClubModuleConstant.action.initialize,
			recentClubStoreInitObj
		);
	}

	public getInitialData(): ltFramework.IRecentClubStoreData {
		return (Store.state as ltFramework.IStoreState).recentClubModule.store;
	}

	public listen(callback: (state: ltFramework.IRecentClubStoreData) => void): () => void {
		return Store.subscribe((mutation: MutationPayload, state: ltFramework.IRootState) => {
			if (mutation.type.includes(RecentClubModuleConstant.name + '/')) {
				callback((state as ltFramework.IStoreState).recentClubModule.store);
			}
		});
	}

	public addRecentClub(club: ltFramework.IClubData, reload: boolean): Promise<void> {
		const addRecentClubObj: ltFramework.IAddRecentClubObj = {
			club,
			reload
		};

		return Store.dispatch(
			RecentClubModuleConstant.name + '/' + RecentClubModuleConstant.action.addRecentClub,
			addRecentClubObj
		);
	}
}
